// extracted by mini-css-extract-plugin
export default {"btn--logout":"Header_btn--logout__-cQPD"};